import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';
import Select from 'react-select';
import { AuthContext } from '../../../../context/AuthContext';

const EditPrimary = ({ onSubmit, restaurantDetailsId }) => {
// console.log(restaurantDetailsId);
   const { apiGlobal } = useContext(AuthContext);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [country, setCountry] = useState([]);
   const [selectCountry, setSelectCountry] = useState({
    value: '',
    label: '',
   });
    const [prevData, setPrevData] = useState(null);

    const fetchRestaurantData = async () => {
        try {
           const url = await 
           fetch(`${apiGlobal}/restaurant_data_fetch.php?id=${restaurantDetailsId}`);
            const data = await url.json();
            if (data.status && data.message === 'Success') {
                setPrevData(data.data[0]);
                setSelectCountry({
                    value: data.data[0].acc_country,
                    label: data.data[0].acc_country_name,
                });
                setSelectedImage(`${apiGlobal}/images/restaurant/${data.data[0].photo}`);
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error loading meals', error);
        }
    };

    useEffect(() => {
        fetchRestaurantData();
    }, [restaurantDetailsId]);


    const fetchCountryList = async () => {
        try {
          const url = await fetch(`${apiGlobal}/currency_master_list.php`);
          const response = await url.json();
          if (response.status && response.message === 'Success') {
            setCountry(response?.data);
          } else {
            setCountry([]);
          }
        } catch (error) {
          console.log(error);
        } 
      };
    
      useEffect(() => {
        fetchCountryList();
      }, []);

  
  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
  
      input.onChange(file);
    } else {
      setSelectedImage(null);
      input.onChange(null);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  // console.log(prevData);

  return (
    <Col md={12} lg={12}>
      <Form onSubmit={onSubmit} initialValues={prevData}>
        {({ handleSubmit, form }) => (
          <FormContainer onSubmit={handleSubmit}>
            {/* Primary Contact Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle />
                  <p><span style={{ color: 'red' }}>*{' '}</span>Marks Fields are Required</p>
                </CardTitleWrap>
                {/* First Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="user_name"
                          component="input"
                          type="text"
                          placeholder="Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field name="country_code_id">
                          {({ input, meta }) => (
                            <div>
                              <select
                                {...input}
                                style={{
                                  height: '45px',
                                  backgroundColor: 'white',
                                  border: '1px solid gray',
                                  width: '100%',
                                  borderRadius: '5px',
                                  paddingLeft: '10px',
                                }}
                                required
                              >
                                <option value="">Select Country Code</option>
                                {country.map(nation => (
                                  <option key={nation.id} value={nation.id}>
                                    {nation.country_code}
                                  </option>
                                                                              ))}
                              </select>
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                                            )}
                            </div>
                                                                          )}
                        </Field>
                        <Field
                          name="user_phone"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          pattern="\d{1,15}"
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="Phone Number"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Second Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="user_email"
                          component="input"
                          type="email"
                          placeholder="Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>UINs #<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uin"
                          component={renderMaskedField}
                          type="text" // switch to text type
                          mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                          placeholder="UIN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    
                  </Col>
                  
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                              style={{ height: '45px' }}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {selectedImage && (
                      <FormGroup>
                        <FormGroupLabel>Selected Logo</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedImage}
                            alt="Selected Logo"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                            required
                          />
                        </FormGroupField>
                      </FormGroup>
                    )}  
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country_name"
                          component="input"
                          type="text"
                          placeholder="Country"
                          required
                          readOnly
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  
                </Row>
              </CardBody>
            </Card>

            {/* Account Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle>Account Details</CardTitle>
                </CardTitleWrap>
                {/* Third Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="acc_name"
                          component="input"
                          type="text"
                          placeholder="Account Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        {/* <Field
                          // name="acc_country"
                          name="acc_country_name"
                          component="input"
                          type="text"
                          placeholder="Country"
                          required
                          readOnly
                        /> */}
                        <Field
                          name="acc_country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="acc_country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              onChange={(selected) => {
                              setSelectCountry(selected);
                              input.onChange(selected.value);
                            }}
                              value={selectCountry}
                              // isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                  

                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fourth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="account_no"
                          component={renderMaskedField}
                          type="text" // switch to text type
                          mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                          placeholder="Account Number"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="acc_city"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fifth Row: 2 columns */}
                <Row>
                  {!prevData.account_no && (
                    <Col md={6}>
                      <FormGroup>
                        <FormGroupLabel>
                          Confirm Account <span style={{ color: 'red' }}>*</span>
                        </FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="conAccount"
                            component="input"
                            type="number"
                            placeholder="Confirm Account"
                            required
                            style={{ height: '45px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                    </Col>
                )}
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Branch<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="branch"
                          component="input"
                          type="text"
                          placeholder="Branch"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Sixth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>IFSC<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="ifsc_code"
                          component="input"
                          type="text"
                          placeholder="IFSC"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Bank<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="bank"
                          component="input"
                          type="text"
                          placeholder="Bank"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <FormButtonToolbar style={{ float: 'right' }}>
              <Button variant="primary" type="submit">Submit</Button>
            </FormButtonToolbar>
          </FormContainer>
      )}
      </Form>
    </Col>
);
};

EditPrimary.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  restaurantDetailsId: PropTypes.string.isRequired,
};

export default EditPrimary;
